import { Outlet } from "react-router-dom";
import { AppSidebar } from "./AppSidebar";
import { useState } from "react";
import { cn } from "@/lib/utils";

interface DashboardLayoutProps {
  role: "admin" | "supplier";
}

export const DashboardLayout = ({ role }: DashboardLayoutProps) => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <AppSidebar role={role} collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />

      <main className={cn("min-h-screen min-w-0 transition-all duration-300", collapsed ? "ml-16" : "ml-56")}>
        <Outlet />
      </main>
    </div>
  );
};
